import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

const styles = theme => ({
  root: {
    whiteSpace: 'nowrap',
    height: '36px',
    padding: '0 16px',
    color: theme.buttons.deleteButtonColor,
    backgroundColor: theme.buttons.deleteButtonBg,
    fontWeight: theme.typography.fontWeightBold,
    '&.rowActionItem': {
      fontSize: theme.typography.fontSizeSmaller,
      fontWeight: theme.typography.fontWeightNormal,
      height: 30,
      minWidth: 30,
      padding: '0 14px',
      'button + &': {
        marginLeft: 10,
        '.buttonGroup &': {
          marginLeft: 1,
        },
      },
    },
    '& a': {
      fontWeight: '300',
    },
    '& a:hover': {
      textDecoration: 'none',
    },
    '&:hover': {
      color: theme.buttons.deleteButtonColor,
      backgroundColor: theme.buttons.deleteButtonBgHover,
    },
    '&:disabled': {
      color: theme.buttons.deleteButtonColor,
      backgroundColor: theme.buttons.deleteButtonBgHover,
      opacity: 0.5,
    },
  },
})

function ClassNames(props) {
  const { className, onClick, variant, ...rest } = props
  return (
    <Button
      variant={variant}
      className={cn(props.classes.root, className)}
      style={{ ...props.style }}
      onClick={onClick}
      {...rest}
    >
      {props.children ? props.children : 'class names'}
    </Button>
  )
}

ClassNames.defaultProps = {
  variant: 'contained',
}

const DeleteButton = withStyles(styles)(ClassNames)
DeleteButton.displayName = 'DeleteButton'
export default DeleteButton
